export default __webpack_public_path__ + "static/media/cee494450f117376.c2ec7947b8d47d80bbd0af3948253dcc.svg";